import React from "react";

const Footer = () => {
    return (
        <footer className="kr-footer">
            <div className="kr-footer-version">
                {process.env.REACT_APP_VERSION}
            </div>
        </footer>
    )
}

export default Footer;